/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Failed_Events_Aria_LabelInputs */

const en_style_guide_failed_events_aria_label = /** @type {(inputs: Style_Guide_Failed_Events_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed Events List`)
};

const fr_style_guide_failed_events_aria_label = /** @type {(inputs: Style_Guide_Failed_Events_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liste des evenements echoues`)
};

const de_style_guide_failed_events_aria_label = /** @type {(inputs: Style_Guide_Failed_Events_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liste der fehlgeschlagenen Ereignisse`)
};

const it_style_guide_failed_events_aria_label = /** @type {(inputs: Style_Guide_Failed_Events_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elenco eventi non riusciti`)
};

const ru_style_guide_failed_events_aria_label = /** @type {(inputs: Style_Guide_Failed_Events_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Список неудачных событий`)
};

const es_style_guide_failed_events_aria_label = /** @type {(inputs: Style_Guide_Failed_Events_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista de eventos fallidos`)
};

const zh_cn2_style_guide_failed_events_aria_label = /** @type {(inputs: Style_Guide_Failed_Events_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`失败事件列表`)
};

const ja_style_guide_failed_events_aria_label = /** @type {(inputs: Style_Guide_Failed_Events_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`失敗したイベントリスト`)
};

const hi_style_guide_failed_events_aria_label = /** @type {(inputs: Style_Guide_Failed_Events_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`असफल घटनाओं की सूची`)
};

const pt_pt2_style_guide_failed_events_aria_label = /** @type {(inputs: Style_Guide_Failed_Events_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista de eventos com falha`)
};

/**
* | output |
* | --- |
* | "Failed Events List" |
*
* @param {Style_Guide_Failed_Events_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_failed_events_aria_label = /** @type {((inputs?: Style_Guide_Failed_Events_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Failed_Events_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_failed_events_aria_label(inputs)
	if (locale === "de") return de_style_guide_failed_events_aria_label(inputs)
	if (locale === "it") return it_style_guide_failed_events_aria_label(inputs)
	if (locale === "ru") return ru_style_guide_failed_events_aria_label(inputs)
	if (locale === "es") return es_style_guide_failed_events_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_failed_events_aria_label(inputs)
	if (locale === "ja") return ja_style_guide_failed_events_aria_label(inputs)
	if (locale === "hi") return hi_style_guide_failed_events_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_failed_events_aria_label(inputs)
	return en_style_guide_failed_events_aria_label(inputs)
});